import { Checkbox, Theme } from '@infotech-soe/erp-ui-kit';
import React, { memo } from 'react';
import { useTheme } from 'react-jss';

import { IPrivsTreeAction } from '../../../models/role-privs/RolePrivsData';

interface Props {
  action: IPrivsTreeAction;
  disabled?: boolean;
}

const PrivsActionsListItem = ({
  action,
  disabled,
}: Props): React.JSX.Element => {
  const { sizes } = useTheme<Theme>();

  return (
    <Checkbox
      disabled={disabled}
      focusable={false}
      hoverColor="inherit"
      label={action.label}
      name={action.actionCode}
      size={sizes.gridCheckbox.size}
      value={!!action.hasAccess}
    />
  );
};

export default memo(PrivsActionsListItem);
